import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { InputX, LayerBottom, Button } from 'components'
import styles from './index.module.css'

const FaqSearch = () => {

	const App = useApp()
	const [showFilter, setShowFilter] = useState(false)
	const [faqOpen, setFaqOpen] = useState()

	const openFilter = () => {
		setShowFilter(true)
	}

	const closeFilter = () => {
		setShowFilter(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding flex_1">
				<div className={styles.title}>FAQ</div>
				<div className="form-group search-bar mt_40">
					<InputX type="text" defaultValue="가입" id="" />
					<i className="icon icon_search" />
				</div>
				<div className="filter-group justify_between mt_40">
					<div><strong>'가입'</strong>에 대한 <span className="text-red">2</span>개의 결과</div>
					<div onClick={openFilter}>
						<span>전체</span>
						<i className="icon icon_filter ml_5" />
					</div>
				</div>
				<ul className={`${styles["faq-list"]} accordion-list mt_10`}>
					<li onClick={() => setFaqOpen(0)} className={faqOpen === 0 ? "active" : ""}>
						<div>
							<div>
								<span className="tag tag-box tag-blue">계정/보안</span>
								<p>본인명의 핸드폰만 가입할 수 있나요?</p>
							</div>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							고객님 본인의 성명, 주민등록번호, 통신사, 휴대폰번호를 입력하고 휴대전화 인증을 받습니다.
							인증절차가 모두 완료되면 추후 자동로그인 시 사용할 간편비밀번호 6자리를 입력하면 회원가입이 완료됩니다.
						</div>
					</li>
					<li onClick={() => setFaqOpen(1)} className={faqOpen === 1 ? "active" : ""}>
						<div>
							<div>
							<span className="tag tag-box tag-blue">이용가이드</span>
								<p>데이터 증명서는 어떻게 공유하나요?</p>
							</div>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							고객님 본인의 성명, 주민등록번호, 통신사, 휴대폰번호를 입력하고 휴대전화 인증을 받습니다.
							인증절차가 모두 완료되면 추후 자동로그인 시 사용할 간편비밀번호 6자리를 입력하면 회원가입이 완료됩니다.
						</div>
					</li>
					<li onClick={() => setFaqOpen(2)} className={faqOpen === 2 ? "active" : ""}>
						<div>
							<div>
							<span className="tag tag-box tag-blue">계정/보안</span>
								<p>회원가입정보는 얼마나 보관되나요?</p>
							</div>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							고객님 본인의 성명, 주민등록번호, 통신사, 휴대폰번호를 입력하고 휴대전화 인증을 받습니다.
							인증절차가 모두 완료되면 추후 자동로그인 시 사용할 간편비밀번호 6자리를 입력하면 회원가입이 완료됩니다.
						</div>
					</li>
					<li onClick={() => setFaqOpen(3)} className={faqOpen === 3 ? "active" : ""}>
						<div>
							<div>
							<span className="tag tag-box tag-blue">기타 문의</span>
								<p>이벤트 당첨 여부는 어디서 확인할 수 있나요?</p>
							</div>
							<i className="icon icon_arrow_sm bottom" />
						</div>
						<div className="menu-open">
							고객님 본인의 성명, 주민등록번호, 통신사, 휴대폰번호를 입력하고 휴대전화 인증을 받습니다.
							인증절차가 모두 완료되면 추후 자동로그인 시 사용할 간편비밀번호 6자리를 입력하면 회원가입이 완료됩니다.
						</div>
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<span className="flex-justify_center mb_20" style={{ color: "#999" }}>원하는 내용을 찾지 못했나요?</span>
				<Button className="btn btn--big">1:1 문의하기</Button>
			</div>

			<FilterLayer show={showFilter} closeLayer={closeFilter} />
		</div>
	)
}

const FilterLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom title="문의 유형" show={show} closeLayer={closeLayer}>
			<ul className="select-list">
				<li className="on">전체</li>
				<li>계정/보안</li>
				<li>이용가이드</li>
				<li>기타 문의</li>
			</ul>
		</LayerBottom>
	)
}

export default FaqSearch
